// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3CWRl","content":"LoadingAlert_content__1rrAy"};